<template>
  <h1 class="hidden">医学生サポーター大募集</h1>
  <div class="mv">
    <div class="mv-sp hiddenPc">
      <img src="@/assets/images/lp/supporters/mv-sp.jpg" alt="" />
    </div>
    <div class="mv-pc hiddenSp"></div>
  </div>
  <section class="supporters-section what">
    <div class="u-containar">
      <div class="h2Wrap">
        <h2>医学生サポーターとは</h2>
      </div>
      <div class="what-flex">
        <div class="imgSet">
          <img src="@/assets/images/lp/supporters/imgSet.png" alt="" />
        </div>
        <p>
          「マイナビRESIDENT」や「合同初期研修プログラム説明会」の案内を、医学生の知人・友人にPRしていただける方を全国で募集しています。<br>詳細は応募後、マイナビの担当者よりメールまたはお電話にてご案内させていただきます。お気軽にご応募ください。
        </p>
      </div>
    </div>
    <div class="btnWrap">
      <div class="u-containar">
        <Button :label="'医学生サポーターに応募する'" secondary :href="'https://survey.mynavi.jp/cre/?enq=PipnLd3WL%2fw%3d'" blank />
      </div>
    </div>
  </section>
  <section class="supporters-section apply">
    <div class="u-containar">
      <h2 class="hidden">募集</h2>
      <section>
        <HeadingLp text="募集要項" />
        <table>
          <tbody>
            <tr>
              <th>内容</th>
              <td>
                医学生の知人・友人に対するLINE・SNS・メールによるマイナビRESIDENT情報の発信など
              </td>
            </tr>
            <tr>
              <th>対象</th>
              <td>4年次・5年次の医学生</td>
            </tr>
            <tr>
              <th>謝礼</th>
              <td>あり</td>
            </tr>
            <tr>
              <th>募集人数</th>
              <td>各学校若干名</td>
            </tr>
          </tbody>
        </table>
        <p class="caption">
          応募者多数の場合はお断りすることがございます、予めご了承ください。<br>※ご連絡まで2週間程お時間をいただく場合がございます。
        </p>
      </section>
      <section>
        <HeadingLp text="実施までの流れ" />
        <ul class="flow">
          <li class="iconSet">
            <img src="@/assets/images/lp/supporters/icon01.png" alt="" />
            <div class="iconSet_txt">
              <h4>step.1</h4>
              <p>下記「応募する」<br class="hiddenSp">ボタンを<br class="hiddenPc">申し込み</p>
            </div>
          </li>
          <li class="iconSet">
            <img src="@/assets/images/lp/supporters/icon02.png" alt="" />
            <div class="iconSet_txt">
              <h4>step.2</h4>
              <p>マイナビ担当者より折り返し<br class="hiddenPc">ご連絡</p>
            </div>
          </li>
          <li class="iconSet">
            <img src="@/assets/images/lp/supporters/icon03.png" alt="" />
            <div class="iconSet_txt">
              <h4>step.3</h4>
              <p>実施に向けてマイナビ担当者とお打ち合わせ</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="btnWrap">
      <div class="u-containar">
        <Button :label="'医学生サポーターに応募する'" secondary :href="'https://survey.mynavi.jp/cre/?enq=PipnLd3WL%2fw%3d'" blank />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Button from '@/components/elements/Button.vue'
import HeadingLp from '@/components/elements/HeadingLp.vue'

export default {
  name: 'Supporters',

  components: {
    Button,
    HeadingLp
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.mv-pc {
  width: 100%;
  height: 240px;
  background-size: cover;
  background-position: center center;
  background-image: url('~@/assets/images/lp/supporters/mv-pc.png');
}

.supporters-section {
  background-color: var.$color-sub-bg-g;
  position: relative;
  overflow: hidden;
  .u-containar {
    @include mixins.media() {
      max-width: 968px;
    }
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    background-size: 100% auto;
    @include mixins.media() {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  p {
    line-height: 1.7;
    margin: -5px 0;
  }
  .btnWrap {
    padding: 24px 0;
    background-color: #d4ebe8;
    a {
      max-width: 300px;
    }
  }
}

.what {
  padding-top: 62px;
  &::before {
    top: -25px;
    height: 150px;
    background-image: url('~@/assets/images/lp/supporters/deco01-sp.png');
    @include mixins.media() {
      top: -40px;
      width: 991px;
      height: 137px;
      background-image: url('~@/assets/images/lp/supporters/deco01-pc.png');
    }
  }
  .h2Wrap {
    text-align: center;
  }
  h2 {
    display: inline-block;
    font-size: 22px;
    line-height: 1.5;
    background: linear-gradient(transparent 70%, var.$color-accent 30%);
    margin-bottom: 35px;
    @include mixins.media() {
      font-size: 24px;
      margin-bottom: 60px;
    }
  }
  .what-flex {
    padding-bottom: 50px;
    @include mixins.media() {
      margin-bottom: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        line-height: 2;
        font-size: 16px;
        margin: -8px 0;
      }
    }
  }
  .imgSet {
    margin-bottom: 30px;
    @include mixins.media() {
      flex-basis: 535px;
      max-width: 535px;
      margin-bottom: 0;
      margin-left: -30px;
    }
  }
  p {
    @include mixins.media() {
      flex-basis: 358px;
      max-width: 358px;
    }
  }
}

.apply {
  > .u-containar {
    padding-top: 70px;
    padding-bottom: 40px;
  }
  &::before {
    top: -40px;
    height: 177px;
    background-image: url('~@/assets/images/lp/supporters/deco02-sp.png');
    @include mixins.media() {
      width: 913px;
      height: 150px;
      background-image: url('~@/assets/images/lp/supporters/deco02-pc.png');
    }
  }
  ::v-deep(.headingLp) {
    margin-bottom: 40px;
  }
  table {
    line-height: 1.7;
    margin-bottom: 22px;
    @include mixins.media() {
      width: 100%;
    }
    th {
      background-color: var.$color-main;
      color: #fff;
      width: 80px;
      @include mixins.media() {
        width: 198px;
      }
    }
    tr {
      border-bottom: 1px solid transparent;
    }
    td {
      background-color: #fff;
      padding: 12.5px 13.5px;
      @include mixins.media() {
        padding: 17px 24px;
      }
    }
  }
  .caption {
    @include mixins.media() {
      font-size: 12px;
      line-height: 1.5;
      margin: -3px 0;
    }
  }
  section + section {
    margin-top: 38px;
    @include mixins.media() {
      margin-top: 80px;
    }
  }
}

.flow {
  @include mixins.media() {
    display: flex;
    align-items: flex-start;
  }
}

.iconSet {
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 20px 13px;
  border: 1px solid #deeceb;
  border-radius: 4px;
  box-shadow: 0 0 14px rgba($color: #7ed3c9, $alpha: 0.2);
  @include mixins.media() {
    flex-basis: 33.3%;
    max-width: 33.3%;
    padding: 32px 20px 32px 10px;
  }
  & + & {
    margin-top: 40px;
    position: relative;
    @include mixins.media() {
      margin-left: 42px;
      margin-top: 0;
    }
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: -26px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 14px 12px 0 12px;
      border-color: var.$color-main transparent transparent transparent;
      @include mixins.media() {
        top: 50%;
        left: -28px;
        border-width: 12px 0 12px 14px;
        border-color: transparent transparent transparent var.$color-main;
        transform: translate(0, -50%);
      }
    }
  }
  > img {
    flex-basis: 82px;
    max-width: 82px;
  }
  &_txt {
    flex: 1;
    margin-left: 30px;
    @include mixins.media() {
      margin-left: 18px;
    }
    > h4 {
      font-size: 16px;
      margin-bottom: 18px;
      line-height: 1;
      color: var.$color-main-text;
      text-transform: uppercase;
    }
  }
}
</style>
